import React, { useContext, useState, useRef, useEffect } from "react";
import "../../assets/css/header/header.css";
import { AuthContext } from "../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo/logo.png";
import useArticles from "../../hooks/useArticle";
import useCategorie from "../../hooks/useCategorie";
import useNotification from "../../hooks/useNotification";
import LoaderHeader from "../loader/header/LoaderHeader";
import { useNotificationRealtime } from "../../contexts/NotificationContext";
import {
  FaHome,
  FaBuilding,
  FaCar,
  FaMotorcycle,
  FaTruck,
  FaBriefcase,
  FaUserTie,
  FaTshirt,
  FaShoePrints,
  FaCouch,
  FaTools,
  FaLaptop,
  FaMobileAlt,
  FaTv,
  FaCamera,
  FaGamepad,
  FaFutbol,
  FaBook,
  FaMusic,
  FaBaby,
  FaDog,
  FaUtensils,
  FaHeartbeat,
  FaGraduationCap,
  FaPlane,
  FaEllipsisH,
  FaServicestack,
  FaCookie,
  FaStarAndCrescent,
  FaStarHalf,
  FaStar,
  FaStarOfLife,
} from "react-icons/fa";
import { formatForUrl } from "../../utils/formatUrl";

const Header = () => {
  const { getAllCategories, getCategoriesGrouped } = useCategorie();
  const [showliste, setShowliste] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [notifications, setNotifications] = useState();
  const { getSuggestion } = useArticles();
  const [search, setSearch] = useState("");
  const [categoriesPrincipales, setCategoriesPrincipales] = useState([]);
  const [categoriesDropdown, setCategoriesDropdown] = useState([]);
  const boxRef = useRef(null);
  const { isLogged, user, isLoading, setIsLoading } = useContext(AuthContext);
  const { unreadCount } = useNotificationRealtime();
  const [groupedCategories, setGroupedCategories] = useState([]);
  const [activeGroup, setActiveGroup] = useState(null);
  const [mobileGroup, setMobileGroup] = useState(null);
  const [isClosing, setIsClosing] = useState(false);

  const iconMap = {
    // Immobilier
    Immobilier: <FaHome />,
    Appartement: <FaBuilding />,
    Maison: <FaHome />,
    Terrain: <FaHome />,

    // Véhicules
    Véhicules: <FaCar />,
    Voiture: <FaCar />,
    Motos: <FaMotorcycle />,
    Moto: <FaMotorcycle />,
    Camion: <FaTruck />,

    // Emploi
    Emploi: <FaBriefcase />,
    "Offre d'emploi": <FaBriefcase />,
    Recrutement: <FaUserTie />,

    // Mode
    Mode: <FaTshirt />,
    Vêtements: <FaTshirt />,
    Chaussures: <FaShoePrints />,

    // Maison & Jardin
    "Maison & Jardin": <FaCouch />,
    Meubles: <FaCouch />,
    Bricolage: <FaTools />,
    Jardin: <FaTools />,

    // Électronique
    Électronique: <FaLaptop />,
    Ordinateurs: <FaLaptop />,
    Informatique: <FaLaptop />,
    Téléphones: <FaMobileAlt />,
    Smartphone: <FaMobileAlt />,
    TV: <FaTv />,
    Télévision: <FaTv />,
    Caméra: <FaCamera />,

    // Loisirs
    Loisirs: <FaGamepad />,
    Jeux: <FaGamepad />,
    Sport: <FaFutbol />,
    Livres: <FaBook />,
    Musique: <FaMusic />,

    // Enfants
    Bébé: <FaBaby />,
    Joué: <FaTools />,
    Enfant: <FaBaby />,

    // Animaux
    Animaux: <FaDog />,

    // Restauration
    Restaurant: <FaUtensils />,
    Alimentation: <FaUtensils />,

    // Santé
    Santé: <FaHeartbeat />,
    Cuisine: <FaCookie />,

    // Formation
    Formation: <FaGraduationCap />,
    Services: <FaServicestack />,
    // Services: <FaStarOfLife />,

    // Voyage
    Voyage: <FaPlane />,

    // Autres
    Autres: <FaEllipsisH />,
  };

  const getGroupIcon = (name) => {
    return iconMap[name] || <FaStarOfLife />;
  };

  const navigate = useNavigate();
  const { getNotifications } = useNotification();

  useEffect(() => {
    if (isLogged && user?._id) {
      getNotifications()
        .then((res) => {
          if (res?.data?.data) {
            setNotifications(res.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    setIsLoading(true);

    setIsLoading(true);

    getCategoriesGrouped()
      .then((res) => {
        const groupes = (res?.data?.data || [])
          // Exclure les groupes archivés
          .filter((groupe) => groupe.archive !== 1)
          // Exclure les catégories archivées
          .map((groupe) => ({
            ...groupe,
            categories: groupe.categories.filter(
              (categorie) => categorie.archive !== 1,
            ),
          }))
          // (optionnel) supprimer les groupes qui n'ont plus de catégories
          .filter((groupe) => groupe.categories.length > 0);
        const sortedGroups = groupes.sort(
          (a, b) => a.rangGroupe - b.rangGroupe,
        );

        const principales = sortedGroups.slice(0, 8);
        const autres = sortedGroups.slice(8);

        setGroupedCategories({ principales, autres });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  }, [isLogged, user?._id]);

  useEffect(() => {
    if (mobileGroup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileGroup]);

  const handleSearch = (valueSearch) => {
    if (valueSearch.length > 2) {
      setShowliste(true);
      getSuggestion(valueSearch).then((res) => {
        if (res?.data?.data) {
          setSuggestions(res.data.data);
        }
      });
    }
  };

  const handleSubmit = () => {
    if (search.length > 2) {
      navigate(`/article/resultat?query=${encodeURIComponent(search)}`);
      setSearch("");
      setShowliste(false);
    }
  };

  const closeSidebar = () => {
    setIsClosing(true);
    setTimeout(() => {
      setMobileGroup(null);
      setIsClosing(false);
    }, 300);
  };

  return (
    <>
      <div className="container p-3 header_container">
        <nav className="navbar navbar-expand-xl navbar-light ">
          <div className="container-fluid" style={{ alignItems: "flex-start" }}>
            {/* LOGO */}
            <img
              src={logo}
              alt="logo"
              className="header_logo"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            />

            {/* BURGER */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span
                className="navbar-toggler-icon"
                style={{ marginLeft: "0px" }}
              ></span>
            </button>

            {/* CONTENT */}
            <div
              className="collapse navbar-collapse"
              id="navbarScroll"
              style={{ alignItems: "flex-start" }}
            >
              {/* SEARCH */}
              <div className="search-section" ref={boxRef}>
                <div className="search-content">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                    className="d-flex header_input mx-lg-5 my-3 my-lg-0"
                  >
                    <input
                      className="header_input_field  header_input_desktop "
                      type="search"
                      placeholder="Rechercher des articles"
                      value={search}
                      aria-label="Search"
                      onChange={(e) => {
                        const val = e.target.value;
                        setSearch(val);
                        handleSearch(val);
                      }}
                    />
                    <i className="bi bi-search header_search_icon  header_input_desktop "></i>
                  </form>
                  {search.length > 2 && showliste && (
                    <div className="suggestion-box">
                      {suggestions && suggestions.length > 0 ? (
                        suggestions.map((s) => (
                          <div
                            key={s._id}
                            onClick={() => {
                              navigate(
                                `/article/resultat?query=${encodeURIComponent(
                                  search,
                                )}`,
                              );
                              setSearch(s.titre || "");
                              setShowliste(false);
                            }}
                            className="suggestion-item"
                          >
                            <div className="suggestion-info">
                              <div className="suggestion-result">
                                <span className="suggestion-title">
                                  {s.titre}
                                </span>{" "}
                                dans
                                <span className="suggestion-title">
                                  {s.categorie}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <>
                          {" "}
                          <div className="suggestion-item text-center">
                            <div className="suggestion-info">
                              <div className="suggestion-result">
                                <span className="suggestion-title">
                                  Aucun résultat
                                </span>{" "}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* ACTIONS */}
              <div className="header_actions ms-lg-auto">
                <Link
                  to="/article/creation"
                  style={{ textDecoration: "none", width: "100%" }}
                >
                  <button className="header_btn_primary mb-2 mb-lg-0">
                    <i
                      className="bi bi-plus-circle-fill"
                      style={{ fontSize: "15.3px" }}
                    ></i>
                    <span style={{ marginTop: "-2px" }}>
                      Commencer à vendre
                    </span>
                  </button>
                </Link>
                {isLogged ? (
                  <>
                    <div className="header_params">
                      <Link
                        to="/utilisateur/compte"
                        style={{ textDecoration: "none" }}
                      >
                        <button className="header_mon_compte">
                          Mon compte
                        </button>
                      </Link>
                      {unreadCount > 0 && (
                        <div className="header_notification">{unreadCount}</div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="d-flex justify-content-center align-items-center header_btn_secondary">
                      <span
                        className="header_span header_signin"
                        role="button"
                        onClick={(e) => navigate("/inscription")}
                      >
                        S'inscrire
                      </span>
                      <span className="header_span">|</span>
                      <span
                        className="header_span header_signin"
                        role="button"
                        onClick={(e) => navigate("/connexion")}
                      >
                        Se connecter
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className="container header_input_mobile">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          className="d-flex header_input"
        >
          <input
            className="header_input_field"
            type="search"
            placeholder="Rechercher des articles"
            aria-label="Search"
            value={search}
            onChange={(e) => {
              const val = e.target.value;
              setSearch(val);
              handleSearch(val);
            }}
          />
          <i
            className="bi bi-search header_search_icon"
            onClick={(e) => {
              navigate(`/article/resultat?query=${encodeURIComponent(search)}`);
              setSearch("");
            }}
          ></i>
        </form>
        {search.length > 2 && showliste && (
          <div className="suggestion-box">
            {suggestions && suggestions.length > 0 ? (
              suggestions.map((s) => (
                <div
                  key={s._id}
                  onClick={() => {
                    navigate(
                      `/article/resultat?query=${encodeURIComponent(search)}`,
                    );
                    setSearch(s.titre || "");
                    setShowliste(false);
                  }}
                  className="suggestion-item"
                >
                  <div className="suggestion-info">
                    <div className="suggestion-result">
                      <span className="suggestion-title">{s.titre}</span> dans
                      <span className="suggestion-title">{s.categorie}</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <>
                {" "}
                <div className="suggestion-item text-center">
                  <div className="suggestion-info">
                    <div className="suggestion-result">
                      <span className="suggestion-title">
                        Aucun résultat
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <div className="container">
        {isLoading ? (
          <>
            <LoaderHeader />{" "}
          </>
        ) : (
          <>
            <div className="category_bar">
              <ul className="category_list">
                {groupedCategories.principales?.map((groupe) => (
                  <li className="category_item_group" key={groupe._id}>
                    <div
                      className="category_group_header"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        if (window.innerWidth <= 768) {
                          setMobileGroup(groupe);
                          setIsClosing(false);
                        } else {
                          setActiveGroup(
                            activeGroup === groupe._id ? null : groupe._id,
                          );
                        }
                      }}
                    >
                      <span className="category_group_title">{groupe.nom}</span>

                      <span
                        className={`arrow_icon ${
                          activeGroup === groupe._id ? "rotate" : ""
                        }`}
                      >
                        ▾
                      </span>
                    </div>

                    {/* DESKTOP MEGA MENU */}
                    <div
                      className={`category_mega_dropdown ${
                        activeGroup === groupe._id ? "active" : ""
                      }`}
                    >
                      <div className="dropdown_container">
                        <div className="dropdown_sidebar">
                          <div className="sidebar_title_wrapper">
                            <h4 className="sidebar_title">
                              <span className="sidebar_icon">
                                {getGroupIcon(groupe.nom)}
                              </span>
                              {groupe.nom}
                            </h4>

                            <button
                              type="button"
                              className="btn-close d-md-none"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setActiveGroup(null);
                              }}
                            />
                          </div>
                        </div>

                        <div className="dropdown_main_content">
                          <ul className="dropdown_grid">
                            {groupe.categories.map((cat) => (
                              <li key={cat._id} className="dropdown_sub_item">
                                <Link
                                  rel="canonical"
                                  to={`/${formatForUrl(groupe.nom)}/${formatForUrl(cat.nom)}?idCategorie=${cat._id}`}
                                  className="dropdown_sub_link"
                                  onClick={(e) => {
                                    // ⚠️ ne pas bloquer clic droit / molette
                                    if (e.button !== 0) return;

                                    e.stopPropagation();
                                    setActiveGroup(null);
                                  }}
                                  style={{
                                    textDecoration: "none",
                                    color: "var(--couleur-dark)",
                                  }}
                                >
                                  {cat.nom}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}

                {groupedCategories.autres?.length > 0 && (
                  <li className="category_item_group">
                    <div
                      className="category_group_header"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        if (window.innerWidth <= 768) {
                          setMobileGroup({ nom: "Autres", isAutres: true });
                        } else {
                          setActiveGroup(
                            activeGroup === "autres" ? null : "autres",
                          );
                        }
                      }}
                    >
                      <span className="category_group_title">Autres</span>
                      <span
                        className={`arrow_icon ${
                          activeGroup === "autres" ? "rotate" : ""
                        }`}
                      >
                        ▾
                      </span>
                    </div>

                    {/* DESKTOP DROPDOWN AUTRES */}
                    <div
                      className={`category_mega_dropdown ${
                        activeGroup === "autres" ? "active" : ""
                      }`}
                    >
                      <div className="dropdown_container">
                        <div className="dropdown_sidebar">
                          <div className="sidebar_title_wrapper">
                            <h4 className="sidebar_title">
                              <span className="sidebar_icon">
                                {getGroupIcon("Autres")}
                              </span>
                              Autres
                            </h4>

                            <button
                              type="button"
                              className="btn-close d-md-none"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setActiveGroup(null);
                              }}
                            />
                          </div>
                        </div>
                        <div className="dropdown_main_content">
                          <div className="others_grid">
                            {groupedCategories.autres.map((groupe) => (
                              <div
                                key={groupe._id}
                                className="other_group_section"
                              >
                                <p className="other_group_name_bold">
                                  {groupe.nom}
                                </p>

                                <ul className="other_sub_list">
                                  {groupe.categories.map((cat) => (
                                    <li
                                      key={cat._id}
                                      className="dropdown_sub_item"
                                    >
                                      <Link
                                        to={`/${formatForUrl(groupe.nom)}/${formatForUrl(cat.nom)}?idCategorie=${cat._id}`}
                                        className="dropdown_sub_link"
                                        onClick={(e) => {
                                          // ⚠️ ne pas bloquer clic droit / molette
                                          if (e.button !== 0) return;

                                          e.stopPropagation();
                                          setActiveGroup(null);
                                        }}
                                        style={{
                                          textDecoration: "none",
                                          color: "var(--couleur-dark)",
                                        }}
                                      >
                                        {cat.nom}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                )}
              </ul>

              {mobileGroup && (
                <div
                  className={`mobile_sidebar_overlay`}
                  onClick={closeSidebar}
                >
                  <div
                    className={`mobile_sidebar ${isClosing ? "closing" : ""}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="mobile_sidebar_header">
                      <h3 className="group_name_mobile">{mobileGroup.nom}</h3>

                      <button
                        className="mobile_close_btn"
                        onClick={() => {
                          closeSidebar();
                        }}
                      >
                        ✕
                      </button>
                    </div>

                    {/* CAS NORMAL */}
                    {!mobileGroup.isAutres && (
                      <ul className="mobile_sub_list">
                        {mobileGroup.categories.map((cat) => (
                          <li key={cat._id}>
                            <Link
                              to={`/${formatForUrl(mobileGroup.nom)}/${formatForUrl(cat.nom)}?idCategorie=${cat._id}`}
                              className="dropdown_sub_link"
                              onClick={(e) => {
                                // ⚠️ ne pas bloquer clic droit / molette
                                if (e.button !== 0) return;

                                e.stopPropagation();
                                setMobileGroup(null);
                              }}
                              style={{
                                textDecoration: "none",
                                color: "var(--couleur-dark)",
                              }}
                            >
                              {cat.nom}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* CAS AUTRES */}
                    {mobileGroup.isAutres && (
                      <div className="mobile_others_container">
                        {groupedCategories.autres.map((groupe) => (
                          <div
                            key={groupe._id}
                            className="mobile_other_section"
                          >
                            <p className="mobile_other_title">{groupe.nom}</p>

                            <ul className="mobile_sub_list">
                              {groupe.categories.map((cat) => (
                                <li key={cat._id}>
                                  <Link
                                    to={`/${formatForUrl(groupe.nom)}/${formatForUrl(cat.nom)}?idCategorie=${cat._id}`}
                                    className="dropdown_sub_link"
                                    onClick={(e) => {
                                      // ⚠️ ne pas bloquer clic droit / molette
                                      if (e.button !== 0) return;

                                      e.stopPropagation();
                                      setMobileGroup(null);
                                    }}
                                    style={{
                                      textDecoration: "none",
                                      color: "var(--couleur-dark)",
                                    }}
                                  >
                                    {cat.nom}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Header;
